import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

import type { CollegePick, ComparisonSettings } from './userColleges.types';
import { logout } from '../session/logout';
import type { RootState } from '../store';

export type CompareDraft = Readonly<{
  picks: readonly CollegePick[];
  settings?: ComparisonSettings;
}>;

const initialState: CompareDraft = { picks: [] };

export const compareDraftSlice = createSlice({
  name: 'compareDraft',
  initialState,
  reducers: {
    setCompareDraft: (state, action: PayloadAction<CompareDraft>) => {
      state.picks = [...action.payload.picks];
      state.settings = action.payload.settings;
    },
    clearCompareDraft: () => initialState,
  },
  extraReducers: (builder) => {
    builder.addCase(logout, () => initialState);
  },
});

export const { setCompareDraft, clearCompareDraft } = compareDraftSlice.actions;

export const selectCompareDraft = (state: RootState): CompareDraft => state.compareDraft;
